// ============================================================
// หน้า InvoiceItemCode — รายการออกใบแจ้งหนี้ (Master)
// ------------------------------------------------------------
// ตั้งรหัสและชื่อรายการ ที่หน้า "ออกใบแจ้งหนี้อื่นๆ" (record-bill) เอาไปให้เลือก
// ใช้สิทธิ์ pay-list เดียวกับหน้ารายการรับชำระ แต่คนละตารางข้อมูล
// ลบได้ทุกแถว (ต่างจากรายการรับชำระที่ซ่อนปุ่มลบแถวแรก)
// ============================================================

import React, { Component } from "react";
import { Modal } from "react-bootstrap";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { tokens, alert_2, GET, POST, PUT, DELETE, validate, required, loading, permission, Paginate, ActionIcon, ConfirmModal, ICON } from "../../shared/index.js";

const perm = permission("pay-list");

export default class InvoiceItemCode extends Component {
  state = {
    modal_create: false,
    modal_update: false,
    modal_delete: false,
    page: 1,
    filter_data_search: "",
    data: null,
    // ฟอร์ม
    invoice_item_id: "",
    code: "",
    title: "",
  };

  componentDidMount() {
    loading(false);
    if (perm.view) this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    const result = await GET(tokens, `v1/TH/document-manage/invoice-item-list/filter-search/page/${this.state.page}`, { data_search: this.state.filter_data_search });
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  // บันทึก — isCreate = true เพิ่มใหม่ / false แก้ไข
  handleSave = async (isCreate) => {
    if (validate(this.state, ["code", "title"])) return;
    loading(true);

    const { invoice_item_id, code, title } = this.state;
    const payload = isCreate ? { code, title } : { invoice_item_id, code, title };
    const result = await (isCreate ? POST : PUT)(tokens, `v1/TH/document-manage/invoice-item-list/${isCreate ? "create" : "update"}`, payload);
    // "#" = โหลดหน้าใหม่หลังกดตกลง
    if (result?.status) alert_2("#", "success");

    loading(false);
  };

  Delete = async () => {
    loading(true);
    const result = await DELETE(tokens, `v1/TH/document-manage/invoice-item-list/delete/${this.state.invoice_item_id}`, null);
    if (result?.status) alert_2("#", "success");
    loading(false);
  };

  closeFormModal = () => this.setState({ modal_create: false, modal_update: false });

  render() {
    const s = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="รายการออกใบแจ้งหนี้" />
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3">
                  <b>รายการออกใบแจ้งหนี้</b>
                </h4>
                {perm.create && (
                  <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => this.setState({ modal_create: true })}>
                    เพิ่มรายการออกใบแจ้งหนี้
                  </button>
                )}
              </div>

              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-left">รหัส</th>
                      <th className="text-left">รายการ</th>
                      {(perm.update || perm.delete) && <th className="text-center wpx-90">จัดการ</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {!s.data?.data?.length ? (
                      <tr>
                        <td colSpan={3} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      s.data.data.map((item, i) => (
                        <tr key={i}>
                          <td>{item.code || "-"}</td>
                          <td>{item.title || "-"}</td>
                          {(perm.update || perm.delete) && (
                            <td className="text-center d-flex">
                              {perm.update && (
                                <ActionIcon color="primary" icon={ICON.edit} title="แก้ไข" className="mr-2" onClick={() => this.setState({ modal_update: true, invoice_item_id: item.invoice_item_id, code: item.code, title: item.title })} />
                              )}
                              {perm.delete && <ActionIcon color="danger" icon={ICON.delete} title="ลบ" onClick={() => this.setState({ modal_delete: true, invoice_item_id: item.invoice_item_id })} />}
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate data={s.data} page={s.page} onChange={(value) => this.setState({ page: value }, this.GetAll)} />
            </div>
          </div>
        </div>

        {/* popup เพิ่ม / แก้ไขรหัสรายการ */}
        <Modal show={s.modal_create || s.modal_update} onHide={this.closeFormModal}>
          <Modal.Header>
            <Modal.Title>
              <b>{s.modal_create ? "เพิ่มรหัสรายการ" : "แก้ไขรหัสรายการ"}</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">รหัสรายการ{required}:</label>
              <input className="form-control border-0 bg-contain validate" type="text" placeholder="กรอกข้อมูล" value={s.code} readOnly={s.modal_update} onChange={(e) => this.setState({ code: e.target.value })} />
            </div>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">ชื่อรายการ{required}:</label>
              <input className="form-control border-0 bg-contain validate" type="text" placeholder="กรอกข้อมูล" value={s.title} onChange={(e) => this.setState({ title: e.target.value })} />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={this.closeFormModal}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={() => this.handleSave(s.modal_create)}>
                  บันทึก
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <ConfirmModal
          show={s.modal_delete}
          title="ยืนยันการลบรหัสรายการ"
          message="ท่านแน่ใจว่าต้องการลบรหัสรายการ หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้"
          onCancel={() => this.setState({ modal_delete: false })}
          onConfirm={this.Delete}
        />
      </div>
    );
  }
}
